import { useContext } from 'react';
import myContext from '../../context/myContext';

const TopAlert = () => {
  const { alert } = useContext(myContext);

  const alertColors = {
    success: 'bg-green-500',
    error: 'bg-red-500',
    warning: 'bg-yellow-500',
    info: 'bg-blue-500',
  };

  return (
    <div
      className={`fixed top-0 left-0 right-0 ${alertColors[alert.type]} text-white text-center py-3 transition-transform duration-500 ease-in-out app-font ${
        alert.show ? 'translate-y-0' : '-translate-y-full'
      }`}
      style={{
        zIndex : 100000
      }}
    >
      {alert.message}
    </div>
  );
};

export default TopAlert;